<div class="login-container">
  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="logo">
      <img
        [src]="
          '/' +
          (themeService.getCurrentTheme() === 'dark'
            ? 'logo-dark.png'
            : 'logo.png')
        "
        alt="BarberPass"
        class="logo"
      />
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        [class.is-invalid]="
          loginForm.get('email')?.invalid && loginForm.get('email')?.touched
        "
      />
      <div
        *ngIf="
          loginForm.get('email')?.invalid && loginForm.get('email')?.touched
        "
        class="invalid-feedback"
      >
        <div *ngIf="loginForm.get('email')?.errors?.['required']">
          Email é obrigatório.
        </div>
        <div *ngIf="loginForm.get('email')?.errors?.['email']">
          Formato de email inválido.
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="password">Senha</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        [class.is-invalid]="
          loginForm.get('password')?.invalid &&
          loginForm.get('password')?.touched
        "
      />
      <div
        *ngIf="
          loginForm.get('password')?.invalid &&
          loginForm.get('password')?.touched
        "
        class="invalid-feedback"
      >
        <div *ngIf="loginForm.get('password')?.errors?.['required']">
          Senha é obrigatória.
        </div>
        <div *ngIf="loginForm.get('password')?.errors?.['minlength']">
          A senha deve ter no mínimo 6 caracteres.
        </div>
      </div>
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <button type="submit" class="btn-submit" [disabled]="!loginForm.valid">
      Entrar
    </button>
    <div class="register-link">
      <p>Não tem uma conta? <a routerLink="/register">Cadastre-se</a></p>
    </div>
  </form>
</div>
